/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './radiology-report-template.reducer';

export const RadiologyReportTemplate = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const radiologyReportTemplateList = useAppSelector(state => state.radiologyReportTemplate.entities);
  const loading = useAppSelector(state => state.radiologyReportTemplate.loading);
  const totalItems = useAppSelector(state => state.radiologyReportTemplate.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="radiology-report-template-heading" data-cy="RadiologyReportTemplateHeading">
        <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.home.title">Radiology Report Templates</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/radiology-report-template/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.home.createLabel">
              Create new Radiology Report Template
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.radiologyReportTemplate.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {radiologyReportTemplateList && radiologyReportTemplateList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('charset')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.charset">Charset</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('charset')} />
                </th>
                <th className="hand" onClick={sort('path')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.path">Path</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('path')} />
                </th>
                <th className="hand" onClick={sort('reportBody')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.reportBody">Report Body</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('reportBody')} />
                </th>
                <th className="hand" onClick={sort('dcTermsTitle')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsTitle">Dc Terms Title</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcTermsTitle')} />
                </th>
                <th className="hand" onClick={sort('dcTermsDescription')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsDescription">Dc Terms Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcTermsDescription')} />
                </th>
                <th className="hand" onClick={sort('dcTermsIdentifier')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsIdentifier">Dc Terms Identifier</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcTermsIdentifier')} />
                </th>
                <th className="hand" onClick={sort('dcTermsType')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsType">Dc Terms Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcTermsType')} />
                </th>
                <th className="hand" onClick={sort('dcTermsLanguage')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsLanguage">Dc Terms Language</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcTermsLanguage')} />
                </th>
                <th className="hand" onClick={sort('dcTermsPublisher')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsPublisher">Dc Terms Publisher</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcTermsPublisher')} />
                </th>
                <th className="hand" onClick={sort('dcTermsRights')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsRights">Dc Terms Rights</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcTermsRights')} />
                </th>
                <th className="hand" onClick={sort('dcTermsLicense')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsLicense">Dc Terms License</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcTermsLicense')} />
                </th>
                <th className="hand" onClick={sort('dcTermsDate')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsDate">Dc Terms Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcTermsDate')} />
                </th>
                <th className="hand" onClick={sort('dcTermsCreator')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsCreator">Dc Terms Creator</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dcTermsCreator')} />
                </th>
                <th className="hand" onClick={sort('voided')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.voided">Voided</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('voided')} />
                </th>
                <th className="hand" onClick={sort('dateVoided')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dateVoided">Date Voided</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dateVoided')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('associationType')}>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.associationType">Association Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('associationType')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.doctor">Doctor</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.lab">Lab</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.test">Test</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.panel">Panel</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.testItem">Test Item</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {radiologyReportTemplateList.map((radiologyReportTemplate, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/radiology-report-template/${radiologyReportTemplate.id}`} color="link" size="sm">
                      {radiologyReportTemplate.id}
                    </Button>
                  </td>
                  <td>{radiologyReportTemplate.charset}</td>
                  <td>{radiologyReportTemplate.path}</td>
                  <td>{radiologyReportTemplate.reportBody}</td>
                  <td>{radiologyReportTemplate.dcTermsTitle}</td>
                  <td>{radiologyReportTemplate.dcTermsDescription}</td>
                  <td>{radiologyReportTemplate.dcTermsIdentifier}</td>
                  <td>{radiologyReportTemplate.dcTermsType}</td>
                  <td>{radiologyReportTemplate.dcTermsLanguage}</td>
                  <td>{radiologyReportTemplate.dcTermsPublisher}</td>
                  <td>{radiologyReportTemplate.dcTermsRights}</td>
                  <td>{radiologyReportTemplate.dcTermsLicense}</td>
                  <td>{radiologyReportTemplate.dcTermsDate}</td>
                  <td>{radiologyReportTemplate.dcTermsCreator}</td>
                  <td>{radiologyReportTemplate.voided ? 'true' : 'false'}</td>
                  <td>{radiologyReportTemplate.dateVoided}</td>
                  <td>{radiologyReportTemplate.microSec}</td>
                  <td>{radiologyReportTemplate.timestampEntry}</td>
                  <td>{radiologyReportTemplate.lastUpdated}</td>
                  <td>{radiologyReportTemplate.cursor}</td>
                  <td>{radiologyReportTemplate.active ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AssociationType.${radiologyReportTemplate.associationType}`} />
                  </td>
                  <td>
                    {radiologyReportTemplate.doctor ? (
                      <Link to={`/doctor/${radiologyReportTemplate.doctor.id}`}>{radiologyReportTemplate.doctor.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {radiologyReportTemplate.lab ? (
                      <Link to={`/diag-lab/${radiologyReportTemplate.lab.id}`}>{radiologyReportTemplate.lab.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {radiologyReportTemplate.test ? (
                      <Link to={`/image-tests/${radiologyReportTemplate.test.id}`}>{radiologyReportTemplate.test.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {radiologyReportTemplate.panel ? (
                      <Link to={`/diag-lab-panel/${radiologyReportTemplate.panel.id}`}>{radiologyReportTemplate.panel.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {radiologyReportTemplate.testItem ? (
                      <Link to={`/lab-test-item/${radiologyReportTemplate.testItem.id}`}>{radiologyReportTemplate.testItem.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/radiology-report-template/${radiologyReportTemplate.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/radiology-report-template/${radiologyReportTemplate.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/radiology-report-template/${radiologyReportTemplate.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.home.notFound">No Radiology Report Templates found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={radiologyReportTemplateList && radiologyReportTemplateList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default RadiologyReportTemplate;
